// mail.service.ts
import { Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { from, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface EmailOptions {
  subject: string;
  body: string;
  email: string | string[];
}

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  constructor(private functions: Functions) {}

  /**
   * Sends an email using Firebase Cloud Function
   * @param emailData Email options containing recipients, subject and body
   * @returns Observable with success message or error
   */
  sendMail(emailData: EmailOptions): Observable<{ message: string }> {
    const sendMailFunction = httpsCallable(this.functions, 'sendMailTrigger');
    console.log('Sending email with data:', emailData);
    return from(sendMailFunction(emailData)).pipe(
      map((result: any) => result.data),
      catchError((error:any) => {
        console.error('Error sending email:', error);
        throw new Error(error.message || 'Failed to send email');
      })
    );
  }

  /**
   * Helper method to send email to multiple recipients
   * @param emails Array of recicpient email addresses
   * @param subject Email subject
   * @param body Email body (HTML supported)
   */
  sendBulkMail(emails: string[], subject: string, body: string): Observable<{ message: string }> {
    return this.sendMail({
      email: emails,
      subject,
      body
    });
  }

  /**
   * Helper method to send email to a single recipient
   * @param email Recipient email address
   * @param subject Email subject
   * @param body Email body (HTML supported)
   */
  sendSingleMail(email: string, subject: string, body: string): Observable<{ message: string }> {
    return this.sendMail({
      email: [email],
      subject,
      body
    });
  }
}
